import { DefaultRootState } from 'react-redux';

import createReducer, { ActionCreatorHelper } from 'store/createReducer';

export interface VideoGalleryItem {
    videoUploadId: string;
    videoUrl: string;
    thumbnailUploadId: string;
    thumbnailUrl: string;
    width: number;
    height: number;
}

const SET_VIDEO_GALLERY = 'SET_VIDEO_GALLERY';
const SET_SELECTED_VIDEO_UPLOAD_ID = 'SET_SELECTED_VIDEO_UPLOAD_ID';
const REMOVE_VIDEO_FROM_GALLERY = 'REMOVE_VIDEO_FROM_GALLERY';
const RESET_SELECTED_VIDEO = 'RESET_SELECTED_VIDEO';

interface PayloadTypes {
    [SET_VIDEO_GALLERY]: VideoGalleryItem[];
    [SET_SELECTED_VIDEO_UPLOAD_ID]: string | null;
    [REMOVE_VIDEO_FROM_GALLERY]: string;
    [RESET_SELECTED_VIDEO]: null;
}

const ActionCreator = ActionCreatorHelper<PayloadTypes>();

export const setVideoGallery = ActionCreator(SET_VIDEO_GALLERY);
export const setSelectedVideoUploadId = ActionCreator(SET_SELECTED_VIDEO_UPLOAD_ID);
export const removeVideoFromGallery = ActionCreator(REMOVE_VIDEO_FROM_GALLERY);
export const resetSelectedVideo = ActionCreator(RESET_SELECTED_VIDEO);

export const selectedVideoGalleryUploadId = (state: DefaultRootState): string | null =>
    state.videoGallery.selectedVideoUploadId;
export const selectVideoGalleryItems = (state: DefaultRootState): VideoGalleryItem[] => state.videoGallery.videos;

export interface VideoGalleryState {
    videos: VideoGalleryItem[];
    selectedVideoUploadId: string | null;
}

export const VIDEO_GALLERY_INITIAL_STATE: VideoGalleryState = {
    videos: [],
    selectedVideoUploadId: null,
};

export default createReducer<VideoGalleryState, PayloadTypes>(VIDEO_GALLERY_INITIAL_STATE, {
    [SET_VIDEO_GALLERY]: (state, { payload }) => ({
        ...state,
        videos: payload,
    }),
    [SET_SELECTED_VIDEO_UPLOAD_ID]: (state, { payload }) => ({
        ...state,
        selectedVideoUploadId: payload,
    }),
    [REMOVE_VIDEO_FROM_GALLERY]: (state, { payload }) => ({
        ...state,
        videos: state.videos.filter((v) => v.videoUploadId !== payload),
        selectedVideoUploadId: state.selectedVideoUploadId === payload ? null : state.selectedVideoUploadId,
    }),
    [RESET_SELECTED_VIDEO]: (state) => ({
        ...state,
        selectedVideoUploadId: null,
    }),
});
